import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "form-group" };
const _hoisted_2 = { class: "col-md-12" };
const _hoisted_3 = { class: "modal-footer justify-between" };
const _hoisted_4 = { class: "col p-0" };
const _hoisted_5 = { class: "col text-end p-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["BModal"], {
        ref: "changeLanguageModal",
        "no-footer": "",
        centered: "",
        size: "lg",
        title: _ctx.$t('JTADM_LAYOUT_CHANGE_LANGUAGE')
    }, {
        default: _withCtx(() => [
            _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        ($setup.locales)
                            ? (_openBlock(), _createBlock($setup["Multiselect"], {
                                key: 0,
                                modelValue: $setup.currentLocale,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.currentLocale) = $event)),
                                options: $setup.locales,
                                searchable: false,
                                "close-on-select": true,
                                "allow-empty": false,
                                "deselect-label": $setup.deselectLabel
                            }, null, 8, ["modelValue", "options"]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]),
            _createElementVNode("footer", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createVNode($setup["BButton"], {
                        variant: "danger",
                        onClick: _cache[1] || (_cache[1] = ($event) => ($setup.changeLanguageModal?.hide()))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('JTADM_CANCEL')), 1)
                        ]),
                        _: 1
                    })
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode($setup["BButton"], {
                        variant: "success",
                        onClick: $setup.confirm
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('JTADM_DIALOG_BUTTON_OK')), 1)
                        ]),
                        _: 1
                    })
                ])
            ])
        ]),
        _: 1
    }, 8, ["title"]));
}
